<template>
    <CompassModal
        v-model:visible="showDialog"
        :title="translations.title"
        :primaryAction="primaryAction"
        :secondaryActions="secondaryActions"
        size="small"
        @closed="$emit('close')"
    >
        <p class="typographies-paragraph-medium-regular">
            {{ translations.message }}
        </p>
    </CompassModal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { deletePendingEInvoicingMandate } from 'api/mandate';
const { mapState: mapStateSystem } = createNamespacedHelpers('system');

export default {
    data() {
        return {
            translations: {
                title: this.$t.__('settings.MandateDeleteDialog.title'),
                message: this.$t.__('settings.MandateDeleteDialog.description'),
            },
            showDialog: true,
            isLoading: false,
        };
    },
    computed: {
        ...mapStateSystem(['errorsHandler']),
        primaryAction() {
            return {
                label: this.$t.__('common.actions.delete'),
                type: 'primary-destructive',
                loading: this.isLoading,
                action: () => this.deleteMandate(),
            };
        },
        secondaryActions() {
            return [
                {
                    label: this.$t.__('common.actions.cancel'),
                    type: 'secondary',
                    action: () => this.$emit('close'),
                },
            ];
        },
    },
    methods: {
        deleteMandate() {
            this.isLoading = true;
            return deletePendingEInvoicingMandate()
                .then(() => {
                    this.$emit('mandateDeleted');
                    this.$pushToast({
                        type: 'success',
                        close: true,
                        text: this.$t.__('settings.MandateDeleteDialog.toast.confirm'),
                    });
                })
                .catch((error) => {
                    this.errorsHandler.logException(error);
                    this.$pushToast({
                        type: 'error',
                        close: true,
                        text: this.$t.__('settings.MandateDeleteDialog.toast.error'),
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                    this.showDialog = false;
                    this.$emit('close');
                });
        },
    },
};
</script>
